import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-contact">
          <span>caminotiszato@gmail.com</span>
          <span className="footer-separator">|</span>
          <span>+36 30 314-3310</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

